.buttonLabel {
	display: flex;
	align-items: center;
}

.buttonText {
	max-width: 250px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
